import {gsap} from "gsap/all";
import $ from "jquery";

export class SecondaryCausalityEffects {

  constructor(el, level) {
    this.$el = $(el);

    this.effects = app.data.content["bioscene_" + level].secondary_causality_effects;
    for (let i = 0; i < this.effects.length; i++) {
      this.effects[i].index = i;
    }

    this.availableEffects = [];
    this.setAllToAvailable()
  }

  setAllToAvailable() {
    this.availableEffects = [...this.effects]
    gsap.set(this.$el.find("canvas"), {autoAlpha: 0});
  }

  triggerAvailableEffect(toolName, dropZone) {
    for (let i = 0; i < this.availableEffects.length; i++) {
      const effect = this.availableEffects[i];
      if (effect.associated_zone === null || effect.associated_zone === toolName) {

        let dropzoneOffset = null;
        if (effect.associated_zone !== null) {
          const rect = dropZone.getBoundingClientRect();
          const ratioHeight = rect.width * (effect.h / effect.w)
          dropzoneOffset = {
            x: rect.left + (rect.width * effect.x),
            y: rect.top + rect.height / 2 - ratioHeight / 2 + (ratioHeight * effect.y),
            width: rect.width,
            height: ratioHeight
          };
        }

        const dotLottie = this.triggerEffect(effect, dropzoneOffset);
        if (effect.associated_zone !== null) $(dropZone).data("secondary-causality", dotLottie);
        this.availableEffects.splice(i, 1);
        return;
      }
    }
    console.log("No secondary causality effects available");
  }

  triggerEffect(effect, offset) {
    const canvas = this.$el.find("canvas").eq(effect.index);
    console.log("trigger secondary effect", effect)
    if (offset) gsap.set(canvas, {...offset, left: 0, top: 0});
    if (effect.z_index) gsap.set(canvas, {zIndex: effect.z_index});
    gsap.to(canvas, {autoAlpha: 1, duration: 0.2});
    const dotLottie = canvas.data('lottie');
    dotLottie.setFrame(0);
    dotLottie.play(0);

    if (effect.audio) app.audio.play(effect.audio, 0.75, true);

    return dotLottie;
  }

  reset() {
    this.setAllToAvailable()
    this.$el.find("canvas").each(function (i, n) {
      const dotLottie = $(n).eq(i).data('lottie');
      if (dotLottie) {
        dotLottie.setFrame(0);
        dotLottie.pause(0);
      }
    })
  }

}
